(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pallet-container"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function() {

});
$(document).on('keyup', '.pallet_search', function(event) {
   event.preventDefault();
   /* Act on the event */
   let searchInput = $(this).val();
   let allVariants = [];
    $('.vitem').each(function(index, el) {
         let currentVariantId = $(el).data("variant_id");
         let currentTitle = $(el).find(".pallet-title").text();
         let currentItem = {id: currentVariantId, title: currentTitle};
         allVariants.push(currentItem);
   });
   const options = {
     includeScore: true,
     minMatchCharLength: 1,
     threshold: 0.2,
     // Search in `title`
     keys: ['title']
   }
   if (searchInput.length > 0 )
   {
      const fuse = new Fuse(allVariants, options)
      const result = fuse.search(searchInput);
      $('.vitem').hide();
      if (result.length > 0)
      {
         $.each(result, function(index, val) {
             /* iterate through array or object */
            let variantId = val.item.id;
            $('#vitem_'+variantId).show();
         });
      }
   }
   else
   {
      $('.vitem').show();
   }
});
$(document).on('click', '.pallet_add_to_cart', function(event) {
   event.preventDefault();
   /* Act on the event */
   let cartDataItem = combinedCartItems();
   
   if (cartDataItem.length > 0) 
   {
      let preparedata = {items: cartDataItem};
      console.log("preparedata",preparedata);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(preparedata)
      })
      .then(response => {
        //return response.json();
        window.location.href  = "/cart";
      })
      .catch((error) => {
        console.error('Error:', error);
        window.location.href  = "/cart";
      });
   }
   console.log(cartDataItem);
});
$(document).on('click', '.Show ', function(event) {
   event.preventDefault();
   /* Act on the event */
   $('.target, .Hide').hide();
   $('.Show').show();
   $(this).parent().find('.Show').hide();   
   $(this).parent().find('.Hide').show();
   $(this).parent().find('.target').show();
});
$(document).on('click', '.Hide ', function(event) {
   event.preventDefault();
   /* Act on the event */
   $('.target, .Hide').hide();
   $(this).parent().find('.Show').show();
});
$(document).mouseup(function(e) 
{
    var container = $(".target");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.hide();
        $(".Hide").hide();
        $(".Show").show();
    }
});
$(document).on('click', '.pallet_qty_inc', function(event) {
   event.preventDefault();
   /* Act on the event */
   let variantId = $(this).data("variantid");   
   let itemLocation = $(this).data("itemlocation");     
   let step = parseInt($('.quantity_pallet_'+itemLocation+'_'+variantId).attr("step"));
   let currentQty = parseInt($('.quantity_pallet_'+itemLocation+'_'+variantId).val());
   let cartLocation = "palletcart_"+itemLocation;
   let currentCartItems = JSON.parse(localStorage.getItem(cartLocation));
   let isincart = currentCartItems.findIndex(o => o["variant_id"] == variantId);
   if (isincart > -1) 
   {
    let palletItem = {... currentCartItems[isincart]};
    palletItem.item_quantity = step;
    let caseCount = checkAddItemCaseCount(palletItem);
    if(isCartOpen(cartLocation, step, palletItem))
    {
      if(isStockAvailable(palletItem.stock_qty, step, variantId))
      {
        let existingQty = currentCartItems[isincart].item_quantity;
        let updatedQty = existingQty+step;
        currentCartItems[isincart].item_quantity = updatedQty;

        let existingCaseCount = currentCartItems[isincart].caseCount;
        let updatedCaseCount = existingCaseCount+caseCount;
        currentCartItems[isincart].caseCount = updatedCaseCount;

        localStorage.setItem(cartLocation, JSON.stringify(currentCartItems));
        $('.quantity_pallet_'+itemLocation+'_'+variantId).val(updatedQty);
      }
       
    }
    else
    {
       palletNotification("The quantity threshold value for this row has been exhausted");
    }  
   }
   else
   {
      palletNotification("Error: Item not found!");
   }
   
   
   checkAddRowStatus();
   renderQuantityPricing();
});
$(document).on('click', '.pallet_qty_dec', function(event) {
   event.preventDefault();
   /* Act on the event */
   let variantId = $(this).data("variantid");   
   let itemLocation = $(this).data("itemlocation");     
   let step = parseInt($('.quantity_pallet_'+itemLocation+'_'+variantId).attr("step"));
   let minQty = parseInt($('.quantity_pallet_'+itemLocation+'_'+variantId).attr("min"));
   let currentQty = parseInt($('.quantity_pallet_'+itemLocation+'_'+variantId).val());
   let cartLocation = "palletcart_"+itemLocation;
   let currentCartItems = JSON.parse(localStorage.getItem(cartLocation));
   let isincart = currentCartItems.findIndex(o => o["variant_id"] == variantId);
   if (isincart > -1) 
   {
    let existingQty = currentCartItems[isincart].item_quantity;
    let updatedQty = existingQty-step;
    if(updatedQty >= minQty)
    {
      currentCartItems[isincart].item_quantity = updatedQty;
      let caseCount = checkAddItemCaseCount(currentCartItems[isincart]);
      currentCartItems[isincart].caseCount = caseCount;
      localStorage.setItem(cartLocation, JSON.stringify(currentCartItems));
      $('.quantity_pallet_'+itemLocation+'_'+variantId).val(updatedQty);
    }
   }
   checkAddRowStatus();
   renderQuantityPricing();
});
$(document).on('click', '.qty_inc', function(event) {
   event.preventDefault();
   /* Act on the event */
   let variantId = $(this).data("variantid");  
   let step = parseInt($('.add_quantity_'+variantId).attr("step"));
   let currentQty = parseInt($('.add_quantity_'+variantId).val());
   $('.add_quantity_'+variantId).val(currentQty+step);
});
$(document).on('click', '.qty_dec', function(event) {
   event.preventDefault();
   /* Act on the event */
   let variantId = $(this).data("variantid");  
   let step = parseInt($('.add_quantity_'+variantId).attr("step"));
   let currentQty = parseInt($('.add_quantity_'+variantId).val());
   let minQty = parseInt($('.add_quantity_'+variantId).attr("min"));
   if( currentQty>minQty )
   {
      $('.add_quantity_'+variantId).val(currentQty-step);
   }
});
$(document).on('click', '.add_item', function(event) {
      event.preventDefault();
      /* Act on the event */
      let currentCartItems;
      let variantId = parseInt($(this).parent('.pallet_add_action').data('variant_id'));
      let itemInfo  = $(this).parent('.pallet_add_action').data('variant_data');
      let quantity = parseInt($('.add_quantity_'+variantId).val());
      let itemLocation = $(this).data('location');
      let cartLocation = "palletcart_"+itemLocation;
      let palletItem = {item_location: itemLocation, item_quantity: quantity, ... itemInfo};
      let caseCount = checkAddItemCaseCount(palletItem);
      palletItem = { caseCount: caseCount, ... palletItem };
      let compatibleRow = checkRowCompatibilty(palletItem, cartLocation);
      console.log("palletItem", palletItem);
      if (checkCartQuantity(cartLocation) === 0 )
      {
        setItemType(palletItem, cartLocation);
      }
      if(isCartOpen(cartLocation, quantity, palletItem))
      {
        if(isStockAvailable(palletItem.stock_qty, palletItem.item_quantity, palletItem.variant_id))
        {
          if (compatibleRow)
          {
            if (localStorage.getItem(cartLocation)  === null) 
            {
               let checkItemType = setItemType(palletItem, cartLocation);            
               if(checkItemType)
               {
                  currentCartItems = [];
                  currentCartItems.push(palletItem);
                  localStorage.setItem(cartLocation, JSON.stringify(currentCartItems));
               }
               else
               {
                  palletNotification("The item is not compataible with this row");
               }
               
            }
            else
            {
               currentCartItems = JSON.parse(localStorage.getItem(cartLocation));
               let isincart = currentCartItems.findIndex(o => o["variant_id"] == variantId);
               if (isincart > -1) 
               {
                  let existingQty = currentCartItems[isincart].item_quantity;
                  let currentQty = quantity;

                  let existingCaseCount = currentCartItems[isincart].caseCount;
                  let currentCaseCount = caseCount;

                  currentCartItems[isincart].item_quantity = existingQty+currentQty;
                  currentCartItems[isincart].caseCount = existingCaseCount+currentCaseCount;
                  localStorage.setItem(cartLocation, JSON.stringify(currentCartItems));
               }
               else
               {
                  let checkExistingItemType = checkWithExistingItemType(palletItem, cartLocation);
                  if(checkExistingItemType)
                  {
                     currentCartItems.push(palletItem);
                     localStorage.setItem(cartLocation, JSON.stringify(currentCartItems));
                  }
                  else
                  {
                     //palletNotification("checkExistingItemType", checkExistingItemType);
                  }
                  
               }         
            }
          }
          else
          {
            palletNotification("This item is not compataible with other row(s).");
          }
        }         
      }
      else
      {
         palletNotification("Quantity limit exceeded");
      }
      renderPallet(cartLocation);
      checkAddRowStatus();
      renderQuantityPricing();
});
$(document).on('click', '.remove_item', function(event) {
   event.preventDefault();
   /* Act on the event */
   let variantId = parseInt($(this).data("variantid"));
   let itemLocation = $(this).data('itemlocation');
   let cartLocation = "palletcart_"+itemLocation;
   let currentCartItems = checkCartQuantity(cartLocation, true);
   let isincart = currentCartItems.findIndex(o => o["variant_id"] == variantId);
   let updateCartItems = [];
   resetCartType(cartLocation);
   console.log("currentCartItems", currentCartItems);
   if (isincart > -1)
   {
      $.each(currentCartItems, function(index, val) 
      {
          /* iterate through array or object */
         if (val.variant_id !== variantId)
         {
            updateCartItems.push(val);
         }
      });
      if (updateCartItems.length > 0)
      {
         localStorage.setItem(cartLocation, JSON.stringify(updateCartItems));
      }
      else
      {
         localStorage.removeItem(cartLocation);
      }
   }
   renderPallet(cartLocation);
   checkAddRowStatus();
   renderQuantityPricing();
   
});
$(document).on('click', '.palletcart_collapse', function(event) {
   event.preventDefault();
   /* Act on the event */
   $(this).parents(".pallet_list_group").find(".pallet_list_item_wrap").toggle();
});
renderPallet("palletcart_top");
renderPallet("palletcart_second");
renderPallet("palletcart_third");
renderPallet("palletcart_bottom");
checkAddRowStatus();
renderQuantityPricing();
function combinedCartItems() 
{
   let cartLocationBottom = checkCartQuantity("palletcart_bottom", true);
   let cartLocationThird = checkCartQuantity("palletcart_third", true);
   let cartLocationSecond = checkCartQuantity("palletcart_second", true);
   let cartLocationTop = checkCartQuantity("palletcart_top", true);
   let cartDataItem = [];
   if (cartLocationBottom !== 0)
   {
      $.each(cartLocationBottom, function(index, val) 
      {
          /* iterate through array or object */
         let item = {id: val.variant_id, quantity: val.item_quantity};
         cartDataItem.push(item);
      });
   }
   if (cartLocationThird !== 0)
   {
      $.each(cartLocationThird, function(index, val) 
      {
          /* iterate through array or object */
         let item = {id: val.variant_id, quantity: val.item_quantity};
         cartDataItem.push(item);
      });
   }
   if (cartLocationSecond !== 0)
   {
      $.each(cartLocationSecond, function(index, val) 
      {
          /* iterate through array or object */
         let item = {id: val.variant_id, quantity: val.item_quantity};
         cartDataItem.push(item);
      });
   }
   if (cartLocationTop !== 0)
   {
      $.each(cartLocationTop, function(index, val) 
      {
          /* iterate through array or object */
         let item = {id: val.variant_id, quantity: val.item_quantity};
         cartDataItem.push(item);
      });
   }
  return cartDataItem;
}
function checkRowCompatibilty(palletItem, cartLocation) 
{
  let status = true;
  let currentRowProductType = $("."+cartLocation).data("product_type");
  let bottomRowProductType = $(".palletcart_bottom").data("product_type");
  let thirdRowProductType = $(".palletcart_third").data("product_type");
  let secondRowProductType = $(".palletcart_second").data("product_type");
  let currentItemProductType = palletItem.product_type;
  switch(cartLocation)
  {
    case "palletcart_bottom":
        if(currentItemProductType == "Bucket" && (thirdRowProductType == "Bag" || secondRowProductType == "Bag"))
        {
          status = false;
        }
    break;
    case "palletcart_third":
      if(currentItemProductType == "Bag" && bottomRowProductType == "Bucket")
      {
        status = false;
      }
      else if(currentItemProductType == "Bucket" &&  secondRowProductType == "Bag")
      {
        status = false;
      }
    break;
    case "palletcart_second":
        if(currentItemProductType == "Bag" && (bottomRowProductType == "Bucket" || thirdRowProductType == "Bucket"))
        {
          status = false;
        }
    break;
    case "palletcart_top":
        status = true;
    break;
  }
  return status;
}
function setItemType(palletItem, cartLocation)
{
    let optionName = palletItem.option;
    let productType = palletItem.product_type;
    let variantType = palletItem.variant_type;
    let status = false;
    let itemType = "";
    let itemQtyLimit = 12;
    switch(cartLocation)
    {
        case "palletcart_top":
                itemQtyLimit = 1;
                if (productType != "Bag" && productType != "Bucket")
                {
                  status = true;
                }
                variantType = '';
        break;
        default:
            switch(productType)
            {
                case "Bucket":
                  if (variantType == "10lb")
                  {
                    itemQtyLimit = 20;
                    status = true;
                  }
                  else if (variantType == "25lb")
                  {
                    itemQtyLimit = 12;
                    status = true;
                  }
                  else
                  {
                    status = false;
                  }
                break;
                case "Bag":
                    if (variantType == "40lb")
                    {
                      itemQtyLimit = 5;
                      status = true;
                    }
                    else if (variantType == "50lb")
                    {
                      itemQtyLimit = 5;
                      status = true;
                    }
                    else
                    {
                      itemQtyLimit = 5;
                      status = true;
                    }
                break;
                default:
                  status = false;
            }
    }
    $("."+cartLocation).data("limit",itemQtyLimit);
    $("."+cartLocation).data("itemtype",itemType);
    $("."+cartLocation).data("product_type",productType);
    $("."+cartLocation).data("variant_type",variantType);
    // console.trace();
    // console.log("productType",productType);
    // console.log("variantType",variantType);
    // console.log("itemQtyLimit",itemQtyLimit);
    // console.log("palletItemcheck",palletItem);
    return status;
}
function resetCartType(cartLocation) {
  //$("."+cartLocation).data("limit",itemQtyLimit);
  $("."+cartLocation).data("itemtype",'');
  $("."+cartLocation).data("product_type",'');
  $("."+cartLocation).data("variant_type",'');
}

function initializedItemType(cartLocation)
{
   let cartItems = checkCartQuantity(cartLocation, true);
   if(cartItems !== 0)
   {
      setItemType(cartItems[0], cartLocation);
   }
}
function checkWithExistingItemType(palletItem, cartLocation)
{
   let status = false;
   let existingItemType = $("."+cartLocation).data("itemtype");
   let existingProductType = $("."+cartLocation).data("product_type");
   let existingVariantType = $("."+cartLocation).data("variant_type");
   let currentItemType = palletItem.option;
   let itemTypeCheck = false;

   switch(cartLocation)
   {
       case "palletcart_top":
           //if (palletItem.product_type === existingProductType)
           if (palletItem.product_type != "Bag" && palletItem.product_type != "Bucket")
           {
             itemTypeCheck = true;
           }
       break;
       default:
           if (palletItem.product_type === existingProductType && palletItem.variant_type === existingVariantType)
           {
            itemTypeCheck = true;
           }
   }
   if (itemTypeCheck) 
   {
      status = true;
   }
   else
   {
      //palletNotification("Current item type "+currentItemType+" does not match existing item type "+existingItemType);
      palletNotification("The item is not compataible with this row.");
   }
   console.log('status', status);

   return status;
}
function renderPallet(cartLocation) 
{
   let cartItemsHtml = '';
   initializedItemType(cartLocation);
   if (localStorage.getItem(cartLocation)  !== null)
   {
      let cartItems = JSON.parse(localStorage.getItem(cartLocation));
      $.each(cartItems, function(index, val) 
      {
          /* iterate through array or object */
        if (val.caseqty > 0)
        {
          cartItemsHtml += `<div class="pallet-item">
             <div class="grid">
                <div class="col-2 m-auto">
                   <div class="pallet-image-wrapper">
                      <a href="#"><img class="pallet-image" src="`+val.image+`" alt=""></a>
                   </div>
                </div>
                <div class="col-4 m-auto">
                   <div class="pallet-info">
                      <p class="pallet-title">`+val.title+`</p>
                      <p class="pallet-price">`+val.price+`</p>
                      <p class="pallet-case">One Case = `+val.caseqty+` `+(val.caseunit || '')+`</p>
                   </div>
                </div>
                <div class="col-4 m-auto">
                   <div class="input-group qunt">
                      <input type="button" value="−" class="button-minus pallet_qty_dec" data-variantid="`+val.variant_id+`" data-itemlocation="`+val.item_location+`">
                      <input readonly="" type="number" step="`+val.caseqty+`" min="`+val.caseqty+`" value="`+val.item_quantity+`" name="quantity_pallet_`+val.item_location+`_`+val.variant_id+`" class="quantity-field quantity_pallet_`+val.item_location+`_`+val.variant_id+`">
                      <input type="button" value="+" class="button-plus pallet_qty_inc" data-variantid="`+val.variant_id+`" data-itemlocation="`+val.item_location+`">
                   </div>
                </div>
                <div class="col-2 m-auto">
                   <button type="button" class="remove_button remove_item" data-variantid="`+val.variant_id+`" data-itemlocation="`+val.item_location+`">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M4 7H20" stroke="#C084FC" stroke-width="1.8" stroke-linecap="round"/>
  
  <path d="M9 4H15C15.55 4 16 4.45 16 5V7H8V5C8 4.45 8.45 4 9 4Z"
        stroke="#C084FC" stroke-width="1.8" stroke-linejoin="round"/>

  <path d="M6 7V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7"
        stroke="#C084FC" stroke-width="1.8" stroke-linejoin="round"/>

  <path d="M10 10V17" stroke="#C084FC" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M14 10V17" stroke="#C084FC" stroke-width="1.8" stroke-linecap="round"/>
</svg>
                   </button>        
                </div>
             </div>
          </div>`;
        }
        else
        {
          cartItemsHtml += `<div class="pallet-item">
             <div class="grid">
                <div class="col-2 m-auto">
                   <div class="pallet-image-wrapper">
                      <a href="#"><img class="pallet-image" src="`+val.image+`" alt=""></a>
                   </div>
                </div>
                <div class="col-4 m-auto">
                   <div class="pallet-info">
                      <p class="pallet-title">`+val.title+`</p>
                      <p class="pallet-price">`+val.price+`</p>
                   </div>
                </div>
                <div class="col-4 m-auto">
                   <div class="input-group qunt">
                      <input type="button" value="−" class="button-minus pallet_qty_dec" data-variantid="`+val.variant_id+`" data-itemlocation="`+val.item_location+`">
                      <input readonly="" type="number" step="1" min="1" value="`+val.item_quantity+`" name="quantity_pallet_`+val.item_location+`_`+val.variant_id+`" class="quantity-field quantity_pallet_`+val.item_location+`_`+val.variant_id+`">
                      <input type="button" value="+" class="button-plus pallet_qty_inc" data-variantid="`+val.variant_id+`" data-itemlocation="`+val.item_location+`">
                   </div>
                </div>
                <div class="col-2 m-auto">
                   <button type="button" class="remove_button remove_item" data-variantid="`+val.variant_id+`" data-itemlocation="`+val.item_location+`">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M4 7H20" stroke="#C084FC" stroke-width="1.8" stroke-linecap="round"/>
  
  <path d="M9 4H15C15.55 4 16 4.45 16 5V7H8V5C8 4.45 8.45 4 9 4Z"
        stroke="#C084FC" stroke-width="1.8" stroke-linejoin="round"/>

  <path d="M6 7V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7"
        stroke="#C084FC" stroke-width="1.8" stroke-linejoin="round"/>

  <path d="M10 10V17" stroke="#C084FC" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M14 10V17" stroke="#C084FC" stroke-width="1.8" stroke-linecap="round"/>
</svg>
                   </button>        
                </div>
             </div>
          </div>`;
        }
      });
   }
   $('.'+cartLocation).html(cartItemsHtml);
}
function checkCartQuantity(cartLocation, returnItems = false) 
{
   let quantity = 0;   
   if(localStorage.getItem(cartLocation) !== null)
   {
      let cartItems = JSON.parse(localStorage.getItem(cartLocation));
      let totalQty = cartItems.reduce((itemqty, item) => item.item_quantity + itemqty , 0);
      quantity = totalQty;
      if (returnItems) 
      {
         quantity = cartItems;
      }   
   }
   return quantity;
}
function isRowCasesFilled(cartLocation) 
{
  let status = false;
  let cartItems = checkCartQuantity(cartLocation, true);
  let nonCaseQtyLimit = 10;
  let totalNonCaseItemQty, quotient, remainder;
  totalNonCaseItemQty = quotient = remainder = 0;
  if (cartItems !== 0)
  {
    $.each(cartItems, function(index, item) {
       /* iterate through array or object */
      if (item.caseqty === 0)
      {
        totalNonCaseItemQty += item.item_quantity;
      }
    });
      
    if (totalNonCaseItemQty > 0)
    {
      quotient = Math.floor(totalNonCaseItemQty / nonCaseQtyLimit);
      remainder = totalNonCaseItemQty % nonCaseQtyLimit;
    }
    if(remainder === 0)
    {
      status = true;
    }
  }
  return status;
}
function checkAddItemCaseCount(palletItem)
{
  let currentCartItems = palletItem;
  let caseCount = 0;
  if (currentCartItems.caseqty > 0 && currentCartItems.item_quantity >= currentCartItems.caseqty)
  {
    caseCount = currentCartItems.item_quantity / currentCartItems.caseqty;
  }
  return caseCount;
}
function isCaseOpen(palletItem) 
{
  let status = false;
  let isNonCaseItem = false;
  let caseLimit = 12;
  let nonCaseQtyLimit = 10;
  let cartLocation = 'palletcart_'+palletItem.item_location;
  let existingCartItems = checkCartQuantity(cartLocation, true);
  
  let currentCaseCount = checkAddItemCaseCount(palletItem);
  let exisingCaseCount = 0;
  let totalCaseCount = 0;
  let totalCaseItemQty = 0;
 

  let currentNonCaseItemQty = 0;
  let existingNonCaseItemQty = 0;
  let totalNonCaseItemQty = 0;

  let quotient, remainder, quotientCaseCount, remainderItemCount;
  quotient = remainder = quotientCaseCount = remainderItemCount = 0;


  if (palletItem.caseqty === 0 )
  {
    isNonCaseItem = true;
    currentNonCaseItemQty = palletItem.item_quantity;
  }
  else
  {
    totalCaseItemQty += palletItem.item_quantity;
  }

  if(existingCartItems !== 0 )
  {
    exisingCaseCount = existingCartItems.reduce((n, {caseCount}) => n + caseCount, 0);
    $.each(existingCartItems, function(index, item) {
       /* iterate through array or object */
      if (item.caseqty === 0 )
      {
        existingNonCaseItemQty += item.item_quantity;
      }
      else
      {
        totalCaseItemQty += item.item_quantity;
      }
    });
  }

  
  totalCaseCount = exisingCaseCount + currentCaseCount;
  totalNonCaseItemQty = existingNonCaseItemQty + currentNonCaseItemQty;
  if (totalNonCaseItemQty > 0 )
  {
    quotient = Math.floor(totalNonCaseItemQty / nonCaseQtyLimit);
    remainder = totalNonCaseItemQty % nonCaseQtyLimit;
  }
  totalCaseCount += quotient;
  if (remainder === 0)
  {
    if (totalCaseCount <= caseLimit)
    {
      status = true;
    }
  }
  else if(remainder > 0)
  {
    if (totalCaseCount <= (caseLimit-1) )
    {
      status = true;
    }
  }
  let caseInfo = {status: status,exisingCaseCount:exisingCaseCount, currentCaseCount:currentCaseCount, existingNonCaseItemQty: existingNonCaseItemQty, currentNonCaseItemQty:currentNonCaseItemQty, totalCaseCount: totalCaseCount,totalCaseItemQty:totalCaseItemQty, totalNonCaseItemQty: totalNonCaseItemQty, quotient: quotient, remainder: remainder};
  //console.log("caseInfo", caseInfo);
  return status;
}
function isStockAvailable(stockQty, addQty, variantId)
{
  let existingItemCount = 0;
  let totalAddQty = 0;
  let allCartData = combinedCartItems();
  if (allCartData.length > 0) {
    $.each(allCartData, function(index, item) {
       /* iterate through array or object */
      if (item.id === variantId) {
        existingItemCount += item.quantity;
      }
    });
  }
  totalAddQty = addQty + existingItemCount;
  let status = false;
  if(stockQty > 0)
  {
    if (totalAddQty <= stockQty)
    {
      status = true;
    }
    else
    {
      palletNotification("Insufficient quantity available in the stock");
    }
  }
  else
  {
    palletNotification("Item is out of stock");
  }
  return status;
}
function isCartOpen(cartLocation, addQty = 0, palletItem = {}) 
{
   let status = false;
   let currentCartQty = checkCartQuantity(cartLocation);
   let cartQtyLimit = $('.'+cartLocation).data("limit");
   if (cartLocation === "palletcart_top")
   {
      let caseInfo = isCaseOpen(palletItem);
      status = caseInfo;
   }
   else
   {
      if(currentCartQty <= cartQtyLimit )
      {
         if (addQty > 0) 
         {
            let remaningQty = cartQtyLimit - currentCartQty;
            if (addQty <= remaningQty) 
            {
               status = true;
            }
         }
         else
         {
            status = true;
         }
      }
   }
   
   return status;
}
function checkAddRow(cartLocation, inputQty = 1) 
{
   switch(cartLocation)
   {
      case "palletcart_top":
        $('.add_item_top').prop('disabled', false);
         /*if (checkCartQuantity("palletcart_second") === 0) 
         {
            $('.add_item_top').prop('disabled', false);
         }
         else
         {
            if(isCartOpen(cartLocation, inputQty))
            {

               $('.add_item_top').prop('disabled', false);
            }
         }*/
      break;
      case "palletcart_second":
         if (checkCartQuantity("palletcart_third") === 0) 
         {
            $('.add_item_second').prop('disabled', true);
         }
         else
         {
            if(isCartOpen(cartLocation, inputQty))
            {
               $('.add_item_second').prop('disabled', false);
            }
         }
      break;
      case "palletcart_third":
         if (checkCartQuantity("palletcart_bottom") === 0) 
         {
            $('.add_item_third').prop('disabled', true);
         }
         else
         {
            if(isCartOpen(cartLocation, inputQty))
            {
               $('.add_item_third').prop('disabled', false);
            }
         }
      break;
      case "palletcart_bottom":
         if(isCartOpen(cartLocation, inputQty))
         {
            $('.add_item_bottom').prop('disabled', false);
         }
      break;
   }
}
function checkAddRowStatus(inputQty = 1) 
{
   let cartLocationBottom = "palletcart_bottom";
   let cartLocationThird = "palletcart_third";
   let cartLocationSecond = "palletcart_second";
   let cartLocationTop = "palletcart_top";
   $('.add_item').prop('disabled', true);
   checkAddRow(cartLocationTop);
   checkAddRow(cartLocationSecond);
   checkAddRow(cartLocationThird);
   checkAddRow(cartLocationBottom);
}
function renderQuantityPricing() 
{
   $(".pallet_add_to_cart").prop("disabled", true);
   let cartLocationBottom = "palletcart_bottom";
   let cartLocationThird = "palletcart_third";
   let cartLocationSecond = "palletcart_second";
   let cartLocationTop = "palletcart_top";
   let cartLocationBottomStatus, cartLocationThirdStatus, cartLocationSecondStatus, cartLocationTopStatus;
   cartLocationBottomStatus = cartLocationThirdStatus = cartLocationSecondStatus = cartLocationTopStatus = false;
   let amount, qty, totalQty, totalAmount;
   qty = totalQty = totalAmount = 0;
   let item_text = "";
   let cartLocationBottomItems = checkCartQuantity(cartLocationBottom, true);
   if (cartLocationBottomItems !== 0) 
   {
      cartLocationBottomStatus = true;
      qty = cartLocationBottomItems.reduce((itemqty, item) => item.item_quantity + itemqty , 0);
      amount = cartLocationBottomItems.reduce((itemqty, item) => item.price_wc * item.item_quantity , 0);
      totalQty += qty;
      totalAmount += amount;
      item_text = qty+" Item(s)";
      $("."+cartLocationBottom+"_qty").text(item_text).removeClass("badge-outline").addClass("badge-solid");
   }
   else
   {
      cartLocationBottomStatus = false;
      item_text = "Empty";
      $("."+cartLocationBottom+"_qty").text(item_text).removeClass("badge-solid").addClass("badge-outline");
   }
   let cartLocationThirdItems = checkCartQuantity(cartLocationThird, true);
   if (cartLocationThirdItems !== 0) 
   {
      cartLocationThirdStatus = true;
      qty = cartLocationThirdItems.reduce((itemqty, item) => item.item_quantity + itemqty , 0);
      amount = cartLocationThirdItems.reduce((itemqty, item) => item.price_wc * item.item_quantity , 0);
      totalQty += qty;
      totalAmount += amount;
      item_text = qty+" Item(s)";
      $("."+cartLocationThird+"_qty").text(item_text).removeClass("badge-outline").addClass("badge-solid");
   }
   else
   {
      cartLocationThirdStatus = false;
      item_text = "Empty";
      $("."+cartLocationThird+"_qty").text(item_text).removeClass("badge-solid").addClass("badge-outline");
   }
   let cartLocationSecondItems = checkCartQuantity(cartLocationSecond, true);
   if (cartLocationSecondItems !== 0) 
   {
      cartLocationSecondStatus = true;
      qty = cartLocationSecondItems.reduce((itemqty, item) => item.item_quantity + itemqty , 0);
      amount = cartLocationSecondItems.reduce((itemqty, item) => item.price_wc * item.item_quantity , 0);
      totalQty += qty;
      totalAmount += amount;
      item_text = qty+" Item(s)";
      $("."+cartLocationSecond+"_qty").text(item_text).removeClass("badge-outline").addClass("badge-solid");
   }
   else
   {
      cartLocationSecondStatus = false;
      item_text = "Empty";
      $("."+cartLocationSecond+"_qty").text(item_text).removeClass("badge-solid").addClass("badge-outline");
   }
   let cartLocationTopItems = checkCartQuantity(cartLocationTop, true);
   let cartLocationTopCaseFilled = isRowCasesFilled(cartLocationTop);
   if (cartLocationTopItems !== 0) 
   {
      if(cartLocationTopCaseFilled)
      {
        cartLocationTopStatus = true;
      }
      else
      {
        cartLocationTopStatus = false;
      }
      qty = cartLocationTopItems.reduce((itemqty, item) => item.item_quantity + itemqty , 0);
      amount = cartLocationTopItems.reduce((itemqty, item) => item.price_wc * item.item_quantity , 0);
      totalQty += qty;
      totalAmount += amount;
      item_text = qty+" Item(s)";
      $("."+cartLocationTop+"_qty").text(item_text).removeClass("badge-outline").addClass("badge-solid");
   }
   else
   {
      cartLocationTopStatus = false;
      item_text = "Empty";
      $("."+cartLocationTop+"_qty").text(item_text).removeClass("badge-solid").addClass("badge-outline");
   }
   let totalQuantityText = totalQty+" item(s) added to pallet";
   let totalAmountText = "Total: $"+totalAmount.toFixed(2);
   $(".palletcart_qty").text(totalQuantityText);
   $(".palletcart_total").text(totalAmountText);
   if (cartLocationBottomStatus && cartLocationThirdStatus && cartLocationSecondStatus && cartLocationTopStatus)
   {
      $(".pallet_add_to_cart").prop("disabled", false);
   }
   else
   {
      $(".pallet_add_to_cart").prop("disabled", true);
   }
}
function palletNotification(message)
{
   toastr.options = {
     "closeButton": true,
     "newestOnTop": false,
     "progressBar": true,
     "positionClass": "toast-top-right",
     "preventDuplicates": false,
     "onclick": null,
     "showDuration": "300",
     "hideDuration": "1000",
     "timeOut": "5000",
     "extendedTimeOut": "1000",
     "showEasing": "swing",
     "hideEasing": "linear",
     "showMethod": "fadeIn",
     "hideMethod": "fadeOut"
   }
   toastr.error(message);
}

  $(document).ready(function() {
  // Function to get the value of a query string parameter
  function getQueryParam(param) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  // Check if 'debug=1' is in the URL
  if (getQueryParam('debug') === '1') {
    // Show all elements with the 'debug-info' class
    $('.debug-info').show();
  }
});


  } catch(e) { console.error(e); }
})();
})();
